import { render, staticRenderFns } from "./DSMakePayment.vue?vue&type=template&id=940a552c&"
import script from "./DSMakePayment.vue?vue&type=script&lang=js&"
export * from "./DSMakePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports